module.exports = __webpack_public_path__ + "static/pellets-hand-df96b5c97c2eac99517cb17865e018c5.jpg";